import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import { INPUT_VARIANT } from "@/common/elements/InputElements/const";
import { IntakeSectionHeader } from "@/common/styles";
import { Col, Row } from "antd";
import { FormContainer } from "../InmateDetails/styles";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import { getOptionsFromRefList } from "@/util/common_function";

const ArrestInformation = ({ formData, updateFormData, disabled }) => {
  return (
    <>
      <section>
        <IntakeSectionHeader>
          <span>Arrest Information</span>
        </IntakeSectionHeader>
        <FormContainer>
          <Row gutter={16}>
            <Col span={12}>
              <FormItem
                name={[
                  "detentionsArrestReports",
                  0,
                  "controllingAgencyCaseNumber",
                ]}
                label="Case #"
                layout="vertical"
              >
                <TextField disabled={disabled} />
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem
                name={["detentionsArrestReports", 0, "controllingAgencyOriId"]}
                label="Controlling Agency ORI"
                layout="vertical"
              >
                <Select
                  options={getOptionsFromRefList(
                    "Controlling_Agency",
                    false,
                    true,
                    true
                  )}
                  placeholder="Controlling Agency ORI"
                  showSearch={false}
                  variant="outlined"
                  disabled={disabled}
                />
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            {/* <Col span={12}>
              <FormItem name="" label="Detention Type" layout="vertical">
                <Select
                  options={getOptionsFromRefList("Inmate_Status")}
                  placeholder="Detention Type"
                  showSearch={false}
                  variant="outlined"
                />
              </FormItem>
            </Col> */}
            <Col span={12}>
              <FormItem
                name={["detentionsArrestReports", 0, "inmateStatusId"]}
                label="Inmate Status"
                layout="vertical"
              >
                <Select
                  options={getOptionsFromRefList(
                    "Inmate_Status",
                    false,
                    false,
                    true
                  )}
                  placeholder="Inmate Status"
                  showSearch={false}
                  variant="outlined"
                />
              </FormItem>
            </Col>
          </Row>
        </FormContainer>
      </section>
    </>
  );
};

export default ArrestInformation;
